export default __webpack_public_path__ + "static/media/cashew_photo.3e5de266.jpg";